import classnames from 'classnames';
import React from 'react';
import { differenceInDays } from 'date-fns';
import styles from './CardLabel.module.css';
export const handleAccessible = (daysLeft: number) => {
  if (daysLeft === null) return null;
  if (daysLeft < 1) {
    return 'Går ut i dag';
  }
  if (daysLeft === 1) {
    return '1 dag kvar';
  }
  if (daysLeft < 8) {
    return `${daysLeft} dagar kvar`;
  }
  return null;
};
interface LabelProps {
  accessibleUntil?: string;
  isCurrentProduct?: boolean;
  nextEpisodeLabel?: string;
}
const CardLabel = ({
  accessibleUntil,
  isCurrentProduct,
  nextEpisodeLabel
}: LabelProps) => {
  let daysLeft = -1;
  if (accessibleUntil) {
    daysLeft = differenceInDays(new Date(accessibleUntil), new Date());
  }
  if ((!accessibleUntil || daysLeft < 0 || daysLeft >= 8) && !nextEpisodeLabel) return null;
  return <span className={classnames(styles.label, {
    [`${styles.active}`]: isCurrentProduct,
    [`${styles.nextEpisode}`]: nextEpisodeLabel
  })} data-sentry-component="CardLabel" data-sentry-source-file="CardLabel.tsx">
      {nextEpisodeLabel || handleAccessible(daysLeft)}
    </span>;
};
export default CardLabel;